var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 24 24"}},_vm.$listeners),[_c('path',{attrs:{"fill":"#525C76","fill-rule":"evenodd","d":"M10.4 10.035a2 2 0 0 1-2.463 1.114A3 3 0 1 0 7 17h8a5 5 0 1 0-4.6-6.965M8.561 9.25A5 5 0 1 0 7 19h8a7 7 0 1 0-6.439-9.751","clip-rule":"evenodd"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }